/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class HeritageRegister {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://kolesar.ivo.lechnerkozpont.hu/api";
    }

    /**
     * Get protection of parcels.
     * @param settlement (optional) 
     * @param parcel (optional) 
     * @return Response with matched parcel objects.
     */
    parcels(settlement: string | undefined, parcel: string | undefined): Promise<ParcelsResponse> {
        let url_ = this.baseUrl + "/parcels?";
        if (settlement === null)
            throw new Error("The parameter 'settlement' cannot be null.");
        else if (settlement !== undefined)
            url_ += "settlement=" + encodeURIComponent("" + settlement) + "&";
        if (parcel === null)
            throw new Error("The parameter 'parcel' cannot be null.");
        else if (parcel !== undefined)
            url_ += "parcel=" + encodeURIComponent("" + parcel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processParcels(_response);
        });
    }

    protected processParcels(response: Response): Promise<ParcelsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ParcelsResponse>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ParcelsResponse>(<any>null);
    }

    /**
     * Log in.
     * @return User details.
     */
    login(body: Body): Promise<Anonymous> {
        let url_ = this.baseUrl + "/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<Anonymous> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <Anonymous>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401: any = null;
                result401 = _responseText === "" ? null : <Message>JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                resultdefault = _responseText === "" ? null : <Message>JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Something went wrong on server side.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Log out.
     * @return Simple message.
     */
    logout(): Promise<Message> {
        let url_ = this.baseUrl + "/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: Response): Promise<Message> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <Message>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401: any = null;
                result401 = _responseText === "" ? null : <Message>JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                resultdefault = _responseText === "" ? null : <Message>JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Something went wrong on server side.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get all items from county associated with user.
     * @return Array of items.
     */
    getAllItemsFromCounty(): Promise<Anonymous2[]> {
        let url_ = this.baseUrl + "/get-all-items-from-county";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllItemsFromCounty(_response);
        });
    }

    protected processGetAllItemsFromCounty(response: Response): Promise<Anonymous2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <Anonymous2[]>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401: any = null;
                result401 = _responseText === "" ? null : <Message>JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                result404 = _responseText === "" ? null : <Message>JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("The specified resource was not found", status, _responseText, _headers, result404);
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                resultdefault = _responseText === "" ? null : <Message>JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Something went wrong on server side.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}

export interface Message {
    message: string;
}

export interface Body {
    /** User ID or email address. */
    userid?: string;
    /** Password in plain text. */
    password?: string;
}

export interface ParcelsResponse {
    success?: boolean;
    filter?: Filter;
    result?: Result[];
}

export interface Anonymous {
    /** Unique user ID as stored in database. Can differ from input parameter `userid` because login does not requre does not require case sensitive match. */
    userid?: string;
    /** Full name of user. */
    fullname?: string;
    /** Email address of user. */
    email?: string;
    /** Name of county associated with user. */
    county?: string | undefined;
    /** Token for authenticating further requests. */
    token?: string;
}

export interface Anonymous2 {
    /** Unique identifier. [azonosító] */
    id?: number;
    /** Legacy inventory number. [törzsszám] */
    number?: number;
    /** Name (default). There can be more than one name associated with an item, only one of them can be selected as default. [név] */
    name?: string;
    /** Protection status. Items are filtered by this field, therefore some statuses do not appear here. Integer key is stored, string is looked up from dictionary. [védettség státusza] */
    protection_status?: string;
    /** Protection type. Integer key is stored, string is looked up from dictionary. [védettség fajtája] */
    protection_type?: string;
    description_short?: string;
    description_status?: string;
    description_topo?: string;
    description_outside?: string;
    description_inside?: string;
    description_history?: string;
    /** County name. Capital "Budapest" appears as a county. [megye] */
    county?: string;
    /** Settlement name. Capital "Budapest" is divided into numbered districts, that appears here. [település] */
    settlement?: string;
    /** Street name and house number if exists. Multiple addresses may belong to one item, only one of them can be selected as default. May contain more than one address in a single string. [cím] */
    address?: string;
    /** Parcel identifiers. May contain more, separated with commas. If list would exceed size limit, may end with "[...]" indicating list is not complete. Numbers may start with zero, therefore content SHOULD NOT be converted to number. [helyrajzi szám] */
    parcels?: string;
    /** Latitude of WGS84 ellipsoidal coordinates. [szélességi koordináta] */
    lat?: number;
    /** Longitude of WGS84 ellipsoidal coordinates. [hosszúsági koordináta] */
    lon?: number;
    /** Last known condition of this item. Integer key is stored, string is looked up from dictionary. [állapot] */
    condition?: string;
}

export interface Filter {
    settlement?: string;
    parcel?: string;
}

export interface Result {
    settlement?: string;
    parcel?: string;
    protection?: string[];
}

export class HeritageRegisterApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isHeritageRegisterApiException = true;

    static isHeritageRegisterApiException(obj: any): obj is HeritageRegisterApiException {
        return obj.isHeritageRegisterApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new HeritageRegisterApiException(message, status, response, headers, null);
}